var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountdownEm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 107,
    viewBox: "0 0 82 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 107
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_2097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9 85.55C38.73 85.55 36.95 84.9 35.57 83.59C34.19 82.28 33.5 80.58 33.5 78.49C33.5 76.4 34.19 74.66 35.57 73.35C36.95 72.04 38.72 71.39 40.9 71.39C43.08 71.39 44.89 72.04 46.27 73.35C47.65 74.66 48.34 76.37 48.34 78.49C48.34 80.61 47.65 82.28 46.27 83.59C44.89 84.9 43.1 85.55 40.9 85.55ZM35.05 65.03L34.13 22.5H47.63L46.71 65.03H35.05Z",
    fill: "#1E1E22",
    stroke: "#1E1E22",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_2097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.83,
    height: 68.05,
    fill: "white",
    transform: "translate(31 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountdownEm);
export default __webpack_public_path__ + "static/media/countdownEM.b3c4f88893e3e32d405b1acf86dfff73.svg";
export { ForwardRef as ReactComponent };